import { render } from "./UsersTabs.vue?vue&type=template&id=08578e82&scoped=true"
import script from "./UsersTabs.vue?vue&type=script&lang=js"
export * from "./UsersTabs.vue?vue&type=script&lang=js"

import "./UsersTabs.vue?vue&type=style&index=0&id=08578e82&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_BO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08578e82"]])

export default __exports__